import React from 'react';
import { MainLayout } from 'components/layout';

const EndpointList = React.lazy(() => import("components/admin/endpoint/EndpointList"));
const EndpointCreate = React.lazy(() => import("components/admin/endpoint/EndpointCreate"));
const EndpointEdit = React.lazy(() => import("components/admin/endpoint/EndpointEdit"));

export const routes = [
    {
        component: EndpointList,
        exact: true,
        path: "/endpoint/list",
        authRequired: true,
        layout:MainLayout,
    },
    {
        component: EndpointCreate,
        exact: true,
        path: "/endpoint/add",
        authRequired: true,
        layout:MainLayout,
    },
    {
        component: EndpointEdit,
        exact: true,
        path: "/endpoint/:id(\\d+)",
        authRequired: true,
        layout:MainLayout,
    },
];
